<template>
  <v-container fluid
               class="d-flex">
    <!--{{statusmap}}-->
    <v-row no-gutters
           class="justify-center rowie">
      <v-col cols="12"
             lg="7"
             class="pa-0">
        <layout-options-card></layout-options-card>
      </v-col>
      <v-col cols="12"
             lg="7"
             class="pa-0 my-3"
             :class="isPadBool ? 'mt-3' : ''">
        <list-item-customization-card></list-item-customization-card>
      </v-col>
      <v-col cols="12"
             lg="7"
             class="pa-0"
             :class="isPadBool ? 'mt-3' : ''">
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import LayoutOptionsCard from "@/views/Sitesettings/cards/LayoutOptionsCard.vue";
import ListItemCustomizationCard from "@/views/Sitesettings/cards/ListItemCustomizationCard.vue";

export default {
  components: { ListItemCustomizationCard, LayoutOptionsCard },

  data() {
    return {};
  },

  mounted() {
    //this.$store.dispatch("BackgroundUpdater/Start", "StatusMap");
  },

  methods: {},

  computed: {
    statusmap() {
      const val = this.$store.getters["BackgroundUpdater/Value"]("StatusMap");

      return val;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped>
.rowie {
  width: 100% !important;
}
</style>
